import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";
import LeftSection from "./get_in_touch_components/LeftSection";
import RightSection from "./get_in_touch_components/RightSection";
import FooterComponent from "./get_in_touch_components/FooterComponent";
import AppBar from "./get_in_touch_components/AppBar";
const StyledContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

const SectionWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "80%",
  margin: "auto",
  minHeight: "calc(100vh - 118px)",
  flexDirection: "row",
  [theme.breakpoints.down("md")]: {
    minHeight: "calc(100vh - 110px)",
    flexDirection: "column",
    width: "100%",
  },
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(2),
}));

const GetInTouchTemplate = ({
  contentState,
  formState,
  secondaryColor,
  logoURL,
  bgURL,
}) => {
  return (
    <>
      <StyledContainer disableGutters fixed maxWidth="false">
        <AppBar logoURL={logoURL} />
        <SectionWrapper>
          <LeftSection bgURL={bgURL}/>

          <RightSection
            contentState={contentState}
            secondaryColor={secondaryColor}
            formState={formState}
          />
        </SectionWrapper>
        <FooterComponent contentState={contentState} />
      </StyledContainer>
    </>
  );
};

export default GetInTouchTemplate;
